import { ChangeDetectionStrategy, Component, EventEmitter, Input, Output } from '@angular/core';

import { ActionItemModel } from '../types';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export abstract class ViewBaseComponent {
  @Input() items?: Array<ActionItemModel>;
  @Input() object?: any;
  @Output() clicked = new EventEmitter<void>();

  onClickItem(event: MouseEvent, item: ActionItemModel) {
    item.action(this.object);
    this.clicked.emit();
  }

  getVisibleItem(item: ActionItemModel) {
    return item.visible !== undefined
      ? typeof item.visible === 'boolean'
        ? item.visible
        : item.visible(this.object)
      : false;
  }

  getVisibleContent() {
    return !!this.items?.filter(item => this.getVisibleItem(item)).length;
  }
}
